import React, { useEffect, useState } from "react";
import { ITkSalaryAdjustmentAmountDialog } from "../../../type/componentsType/TkSalaryAdjustmentAmountDialog";
import TkModal from "../../atoms/TkModal";
import { Box } from "@mui/material";
import TkTitle from "../../atoms/TkTitle";
import TkButton from "../../atoms/TkButton";
import "./_style.scss";
import { AllowanceType } from "../../../assets/data/Constants";
import TkCheckbox from "../../atoms/TkCheckbox";
import _ from "lodash";

/**
 * TkSalaryAdjustmentAmountDialogコンポーネントは、給与調整金額のダイアログを表示するためのコンポーネントです。
 * ユーザーは選択リストから項目を選択し、確認ボタンをクリックすることで選択した項目を渡すことができます。
 *
/**
 * @param open - ダイアログの表示状態 (boolean)
 * @param onConfirm - 確認ボタンのクリックイベントハンドラ (function)
 * @param onClose - 閉じるボタンのクリックイベントハンドラ (function)
 * @param title - ダイアログのタイトル (string)
 * @param selList - 選択リスト (array)
 * @param selectedList - 選択されたリスト (array)
 * @returns Reactコンポーネント
 */
const TkSalaryAdjustmentAmountDialog: React.FC<
  ITkSalaryAdjustmentAmountDialog
> = (props) => {
  const {
    open = false, // ダイアログの表示状態
    onConfirm, // 確認ボタンのクリックイベントハンドラ
    onClose, // 閉じるボタンのクリックイベントハンドラ
    title, // ダイアログのタイトル
    selList, // 選択リスト
    selectedList = [], // 選択されたリスト
  } = props;
  const [selListState, setSelListState] = useState<any>([]); // 選択リストの状態
  const [seledList, setSeledList] = useState<any>([]); // 選択されたリストの状態

  useEffect(() => {
    // 選択リストをカテゴリごとにグループ化する
    const result = selList.reduce(
      (acc: { [key: string]: typeof selList }, item) => {
        const key = item.classfiy
          ? AllowanceType[item.classfiy]
          : AllowanceType["3"];
        if (!acc[key]) {
          acc[key] = [];
        }
        acc[key].push(item);
        return acc;
      },
      {}
    );
    setSelListState(result);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); //selList

  useEffect(() => {
    // 選択されたリストが変更された場合、状態を更新する
    if (!_.isEqual(selectedList, seledList)) {
      setSeledList(selectedList);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedList]);

  const handleConfirm = () => {
    // 確認ボタンがクリックされた場合、選択されたリストを渡す
    onConfirm && onConfirm(seledList);
  };

  const handleChange = (e: any) => {
    const { checked, value } = e.target;
    const selectedItem = selList.find((item: any) => item.value === value);

    if (checked) {
      // チェックが付いた場合、選択されたリストに追加する
      setSeledList([...seledList, selectedItem]);
    } else {
      // チェックが外れた場合、選択されたリストから削除する
      const updatedList = seledList.filter((item: any) => item.value !== value);
      setSeledList(updatedList);
    }
  };

  return (
    <TkModal open={open}>
      <Box className="tkSalaryAdjustmentAmountDialog">
        <Box className="titleBox">
          <TkTitle size="small">{title}</TkTitle>

          <Box>
            <TkButton onClick={handleConfirm}>選択して閉じる</TkButton>
            <TkButton onClick={() => onClose && onClose()} ml>
              キャンセル
            </TkButton>
          </Box>
        </Box>

        <Box className="listSec">
          {Object.keys(selListState).map((key, index) => {
            const list = selListState[key];

            return (
              <Box key={index} className="item">
                <TkTitle size="small">{key}</TkTitle>
                <Box className="list">
                  {list.map((item: any, index: any) => {
                    return (
                      <TkCheckbox
                        checked={seledList.some(
                          (selItem: any) => selItem.value === item.value
                        )}
                        onChange={handleChange}
                        key={index}
                        label={item.label}
                        value={item.value}
                      />
                    );
                  })}
                </Box>
              </Box>
            );
          })}
        </Box>
      </Box>
    </TkModal>
  );
};

export default TkSalaryAdjustmentAmountDialog;
